"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constraints;
(function (Constraints) {
    Constraints[Constraints["BACKEND_MAX_PAGE_SIZE"] = 250] = "BACKEND_MAX_PAGE_SIZE";
})(Constraints || (Constraints = {}));
exports.default = Constraints;
//# sourceMappingURL=constraints.js.map